import { Button } from '@seen/ui'
import { IconChevronDown } from '@tabler/icons-react'
import type { JSX, ReactNode } from 'react'
import { DropdownMenu } from '#src/components/core/dropdown-menu/DropdownMenu.tsx'
import { DropdownMenuContent } from '#src/components/core/dropdown-menu/DropdownMenuContent.tsx'
import { DropdownMenuItem } from '#src/components/core/dropdown-menu/DropdownMenuItem.tsx'
import { DropdownMenuTrigger } from '#src/components/core/dropdown-menu/DropdownMenuTrigger.tsx'
import { IconView } from '#src/components/icons/IconView.tsx'
import { IconViewPlus } from '#src/components/icons/IconViewPlus.tsx'

export function ViewEditorRow({
  filterEditor,
  displayEditor,
  editable,
  isDirty,
  onReset,
  onUpdate,
  onCreate,
}: {
  filterEditor: ReactNode
  displayEditor: ReactNode
  editable: boolean
  isDirty: boolean
  onReset: () => void
  onUpdate: () => void
  onCreate: () => void
}): JSX.Element {
  return (
    <div className="flex items-start justify-between gap-2 border-b-[0.5px] px-pagex-default py-2 lg:px-pagex-lg">
      {filterEditor}
      <div className="flex items-center gap-2">
        {displayEditor}
        <div className="ml-2 h-4 w-[0.5px] bg-border" />
        <Button variant="ghost" size="xs" disabled={!isDirty} onClick={onReset}>
          Reset
        </Button>
        {editable && (
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button variant="outline" size="xs" className="gap-1">
                Save
                <IconChevronDown className="size-3.5 shrink-0" />
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end">
              <DropdownMenuItem onSelect={onUpdate}>
                <IconView />
                Save to this view
              </DropdownMenuItem>
              <DropdownMenuItem onSelect={onCreate}>
                <IconViewPlus />
                Create new view…
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        )}
        {!editable && (
          <Button variant="outline" size="xs" onClick={onCreate}>
            Save
          </Button>
        )}
      </div>
    </div>
  )
}
